export default __webpack_public_path__ + "static/media/network-lg-bg.1bd3539c.png";